import { tw } from "@careinfo/tailwind";
import { Switch } from "@headlessui/react";

interface Props {
  label?: string;
  onChange: (isOn: boolean) => void;
  checked: boolean;
}

export default ({ label = " ", onChange, checked }: Props) => {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      className={tw`inline-flex focus:outline-none h-4 w-9 items-center rounded-full bg-gray-200 transition ${
        checked && "bg-green-400"
      }`}
    >
      {label}
      <span
        className={tw`w-2 h-2 inline-block translate-x-1 rounded-full bg-white transition ${
          checked && "translate-x-6"
        }`}
      />
    </Switch>
  );
};
